module.exports = __webpack_public_path__ + "img/1506504021.ec82f06a.jpg";